import {StageDomainModel} from "../../../../domain/full-game/models/stage/stage-domain-model";
import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import {makeObservable, observable} from "mobx";

export class GameCardScoreboardViewModel extends BaseViewModel {
  @observable competitorInPossessionIndex: Number;

  constructor(domainModel: StageDomainModel, competitorInPossessionIndex: Number) {
    super(domainModel);

    this.competitorInPossessionIndex = competitorInPossessionIndex;
    makeObservable(this);
  }

  get isMain(): Boolean {
    return this.domainModel.isCurrent;
  }
  get isLive(): Boolean {
    return this.domainModel.isLive;
  }

  get winnerScoreIndex(): Number {
    let winnerScoreIndex: Number = -1;
    if(this.domainModel.isEnded) {
      winnerScoreIndex = this.domainModel.homeCompetitorScore > this.domainModel.awayCompetitorScore ? 0 : 1;
    }
    return winnerScoreIndex
  }

  get homeScore(): String {
    return this.domainModel.homeCompetitorScore > -1 ? this.domainModel.homeCompetitorScore : '-';
  }

  get awayScore(): String {
    return this.domainModel.awayCompetitorScore > -1 ? this.domainModel.awayCompetitorScore : '-';
  }

  get scores(): Array<String> {
    return [this.homeScore, this.awayScore];
  }

  get extraScores(): Array<String> {
    return this.domainModel.homeCompetitorExtraScore ? [this.domainModel.homeCompetitorExtraScore, this.domainModel.awayCompetitorExtraScore] : [];
  }

  get columnTitle(): String {
    return this.domainModel.shortName;
  }


}
